import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ErrorMessage } from '../error-message.component';

export function HasNotCompaniesError(): JSX.Element {
  return (
    <ErrorMessage>
      <Typography>
        Your account has been successfully activated, but must be linked to a company before you can
        fully access our platform.
      </Typography>
      <Typography>{"Please contact your company's administrator for assistance."}</Typography>
      <Typography>Thank you!</Typography>
      <Box sx={{ textAlign: 'center' }}>
        <Button component={RouterLink} to='/'>
          Login
        </Button>
      </Box>
    </ErrorMessage>
  );
}
